import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import { customPalette } from '../../themes/customTheme';
import { apiUrl, httpClient } from '../../utils/httpUtils';
import { hasRole } from '../../utils/roles';

export const Evolution = ({ teamId = null, userId = null }) => {
  const t = useTranslate();
  const [data, setData] = useState([]);

  const getDate = date => {
    return format(new Date(date), 'MMMM yyyy', { locale: es });
  };

  const getHistory = async () => {
    try {
      const url = `${apiUrl}/scores/${hasRole(['editor']) && !hasRole(['redactor']) && teamId ? `teams/${teamId}` : `members/${userId}`}/history`;
      const res = await httpClient(url);
      if (res.status === 200) {
        const result = await res.json;
        setData(result);
      }
    } catch (error) {
      console.error('Failed to fetch metrics:', error);
    }
  };

  useEffect(() => {
    getHistory();
  }, [teamId]); // eslint-disable-line react-hooks/exhaustive-deps

  if (data.length > 0) return <CircularProgress />;

  return (
    <Card
      elevation={0}
      sx={{
        background: '#fff',
        color: '#000',
        padding: '24px',
        marginTop: 2,
        marginBottom: '1em',
      }}
    >
      <Box>
        <Typography
          fontSize={26}
          fontWeight="600"
          sx={{ marginBottom: '16px' }}
        >
          {t('resources.score.list.evolution_title')}
        </Typography>
      </Box>
      <CardContent sx={{ padding: 0 }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    width: '200px',
                  }}
                >
                  {t('resources.score.list.fields.month')}
                </TableCell>
                <TableCell sx={{ width: '170px' }}>
                  {t('resources.score.list.fields.points')}
                </TableCell>
                <TableCell sx={{ width: '170px' }}>
                  {t('resources.score.list.fields.accumulated')}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.data?.map((month, i) => {
                return (
                  <TableRow
                    key={i}
                    sx={{
                      '&:hover': {
                        backgroundColor: customPalette.greyStoke,
                      },
                    }}
                  >
                    <TableCell>
                      <Typography
                        sx={{
                          textTransform: 'capitalize',
                          fontSize: 16,
                          fontWeight: 400,
                          lineHeight: '21px',
                        }}
                      >
                        {getDate(month.month)}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ display: 'flex', marginLeft: '12px' }}>
                      {Intl.NumberFormat('es-AR', {
                        maximumFractionDigits: 2,
                      }).format(month?.total_points || 0)}
                    </TableCell>
                    <TableCell>
                      {Intl.NumberFormat('es-AR', {
                        maximumFractionDigits: 2,
                      }).format(month?.accumulated_points || 0)}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};
